const sessionWarningTime = 20;
const sessionCountdownTime = 10;

export { sessionWarningTime, sessionCountdownTime };
